import React, { useEffect, useReducer, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal, {
  ModalBody,
  ModalCustomContent,
} from '../../components/modal/Modal';
import MoreViewsMenu from './MoreViewsMenu';
import _ from 'lodash';
import { SvgIcon } from '../../../core/icons';
import { connect } from 'react-redux';
import MoreViewsCarousel from './MoreViewsCarousel';
import { toggleConvertibleTop } from '../../store/actions';
import LegalDisclosure from '../../components/legalDisclosure/LegalDisclosure';
import { useTranslate } from '../../../core/translate';

const CONTROLS_MAP = {
  hasRoof: {
    labels: { trueLbl: 'roof.off.v3', falseLbl: 'roof.on.v3' },
    messageAction: 'toggleRoof',
    icons: { trueIcn: 'roof-toggle', falseIcn: 'roof-toggle' },
    navOrder: 2,
  },
  hasInterior: {
    labels: { trueLbl: 'view.interior.v3', falseLbl: 'view.exterior.v3' },
    messageAction: 'toggleView',
    icons: {
      trueIcn: 'interior-toggle',
      falseIcn: 'exterior-toggle',
    },
    navOrder: 1,
  },
};

const controlReducer = (state, { type, payload }) => {
  let controlIndex = 0;
  let controlObj = null;
  switch (type) {
    case 'toggle':
      controlIndex = state.findIndex(
        (controlItem) => controlItem.messageAction === payload
      );
      controlObj = state[controlIndex];
      if (controlObj) {
        return Object.assign([], state, {
          [controlIndex]: {
            ...controlObj,
            isToggled: !controlObj.isToggled,
          },
        });
      }
      return state;
    case 'init':
      return Object.entries(payload)
        .reduce((accum, [key, value]) => {
          const { labels, messageAction, icons, navOrder } = CONTROLS_MAP[key];
          return [
            ...accum,
            { key, labels, messageAction, isToggled: value, icons, navOrder },
          ];
        }, [])
        .sort((a, b) => a.navOrder - b.navOrder);
    default:
      return state;
  }
};

const MoreViewsTwoD = ({
  cgiBackgroundColor,
  config,
  cgi,
  onToggleConvertibleTop,
}) => {
  const navigate = useNavigate();
  const [controlState, dispatchControlAction] = useReducer(controlReducer, []);
  const onToggleInterior = () => {
    setIsExteriorView(!isExteriorView);
  };

  const search = useLocation().search;

  const isExteriorViewParam = new URLSearchParams(search).get('isExterior');
  const isConvertible = _.get(config.bodyType, 'showConvertible', false);
  const isConvertibleTopDown = cgi.isConvertibleTopDown;
  const [isExteriorView, setIsExteriorView] = useState(
    isExteriorViewParam !== null ? isExteriorViewParam === 'true' : true
  );
  const toggles = isConvertible
    ? {
        hasRoof: !isConvertibleTopDown,
        hasInterior: isExteriorView,
      }
    : {
        hasInterior: isExteriorView,
      };
  const angle = new URLSearchParams(search).get('angle');

  const translate = useTranslate();
  const closeAlt = translate('byo.page.general.close');

  useEffect(() => {
    dispatchControlAction({
      type: 'init',
      payload: toggles,
    });
  }, []);

  const onToggle = (action) => {
    dispatchControlAction({ type: 'toggle', payload: action.id });

    if (action.id === 'toggleRoof') {
      onToggleConvertibleTop();
    }

    if (action.id === 'toggleView') {
      onToggleInterior();
    }
  };

  const onClose = () => {
    navigate('..');
  };

  const analyticsKey = `gallery:${
    isExteriorView ? 'exterior' : 'interior'
  }:pano`;

  const menuAnalyticsKey = analyticsKey + ':toggle menu bar';

  return (
    <Modal isOpen={true} onRequestClose={onClose}>
      <ModalCustomContent>
        {({ setIsClosing, onCloseModal }) => (
          <>
            <div className="more-views__legal-disclosure">
              <LegalDisclosure isRelative />
              <button
                onClick={() => setIsClosing(true, onCloseModal(onClose))}
                className="more-views__close-btn stat-button-close"
                data-dtm={analyticsKey}
                aria-label={closeAlt}>
                <SvgIcon
                  className="more-views__close-icon"
                  name="more-views-close"
                />
              </button>
            </div>
            <ModalBody innerClassName="more-views__modal-body">
              <div className="more-views__carousel-container">
                <MoreViewsCarousel
                  isExteriorView={isExteriorView}
                  isConvertibleTopDown={isConvertibleTopDown}
                  imageAngle={angle}
                  fallbackText={translate('fallback.image.label.v3')}
                />
              </div>
              <MoreViewsMenu
                analyticsKey={menuAnalyticsKey}
                onClose={() => setIsClosing(true, onCloseModal(onClose))}
                controls={controlState}
                onToggle={onToggle}
                disableControls={false}
              />
            </ModalBody>
          </>
        )}
      </ModalCustomContent>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { cgi, config } = state;
  return {
    cgi,
    config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleConvertibleTop: () => dispatch(toggleConvertibleTop()),
  };
};

export { controlReducer };
export default connect(mapStateToProps, mapDispatchToProps)(MoreViewsTwoD);
